import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { lenisRef } from "@/components/site/data";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { PropertyOwners } from "@/components/site/PropertyOwners";
import { OwnerTools } from "@/components/site/OwnerTools";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Toaster } from "@/components/ui/sonner";
import { Retrieval } from "@/components/site/Retrieval";
import { ServiceArea } from "@/components/site/ServiceArea";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); lenisRef.current = null; };
  }, []);

  return (
    <div className="grain relative min-h-screen overflow-x-clip bg-[var(--ink)] text-[var(--bone)]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <PropertyOwners />
        <OwnerTools />
        <QuoteForm />
        <Retrieval />
        <ServiceArea />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
